




































import { Component, Vue } from 'vue-property-decorator';
@Component
export default class TopToolbar extends Vue {
  private showMenu: boolean = false;
  public toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }
}
